import {
  Create,
  Edit,
  Datagrid,
  DateField,
  List,
  Resource,
  Show,
  SimpleForm,
  SimpleShowLayout,
  TextField,
  TextInput,
  SelectInput
} from 'react-admin';
import { FilterSidebar } from '../components/FilterSidebar';
import gql from 'graphql-tag';

export const name = 'AiPromptVariable';
export const fragments = {
  type: 'document',
  doc: gql`
    fragment FragAiPromptVariables on aiPromptVariables {
      id
      aiPromptId
      name
      script
      sequence
      type
      createdAt
      updatedAt
      aiPrompt {
        id
        name
        __typename
      }
      __typename
    }
  `
};

const list = () => (
  <List aside={<FilterSidebar />} sort={{ field: 'name', order: 'ASC' }}>
    <Datagrid rowClick="show">
      <TextField source="name" />
      <TextField source="type" />
      <TextField source="sequence" />
      <TextField source="script" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </Datagrid>
  </List>
);

const show = () => (
  <Show>
    <SimpleShowLayout>
      <TextField source="name" />
      <TextField source="type" />
      <TextField source="sequence" />
      <TextField source="script" />
      <DateField source="createdAt" />
      <DateField source="updatedAt" />
    </SimpleShowLayout>
  </Show>
);

const edit = () => (
  <Edit mutationMode="pessimistic">
    <SimpleForm>
      <TextField source="id" />
      <TextInput source="name" />
      <SelectInput
        source="type"
        choices={{
          sql: 'SQL',
          httpQuery: 'HTTP Query'
        }}
      />
      <TextInput source="script" multiline rows={4} fullWidth />
    </SimpleForm>
  </Edit>
);

const create = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" />
      <SelectInput
        source="type"
        choices={{
          sql: 'SQL',
          httpQuery: 'HTTP Query'
        }}
      />
      <TextInput source="script" multiline rows={4} fullWidth />
    </SimpleForm>
  </Create>
);

export default function AdminResource(props) {
  return (
    <Resource
      create={create}
      edit={edit}
      list={list}
      name={name}
      show={show}
      {...props}
    />
  );
}
